/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * CIT
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DashBoardModelApiResponse,
  EnquiryBySourcePagedDataEnquiryBySourceResponseApiResponse,
  GetAPIDashBoardGetEnquiryBySourceParams,
  GetAPIDashBoardGetSourseByDateParams,
  GetAPIDashBoardGetStraeamDataParams,
  GetAPIDashBoardGetStudentStatusParams,
  ObjectApiResponse
} from '../cit.schemas';

import { customAxios } from '../../../Utilities/customAxios';




export const getAPIDashBoardGetStudentStatus = (
    params?: GetAPIDashBoardGetStudentStatusParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DashBoardModelApiResponse>(
      {url: `/API/DashBoard/GetStudentStatus`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIDashBoardGetStudentStatusQueryKey = (params?: GetAPIDashBoardGetStudentStatusParams,) => {
    return [`/API/DashBoard/GetStudentStatus`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIDashBoardGetStudentStatusQueryOptions = <TData = Awaited<ReturnType<typeof getAPIDashBoardGetStudentStatus>>, TError = unknown>(params?: GetAPIDashBoardGetStudentStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetStudentStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIDashBoardGetStudentStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIDashBoardGetStudentStatus>>> = ({ signal }) => getAPIDashBoardGetStudentStatus(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetStudentStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIDashBoardGetStudentStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIDashBoardGetStudentStatus>>>
export type GetAPIDashBoardGetStudentStatusQueryError = unknown


export function useGetAPIDashBoardGetStudentStatus<TData = Awaited<ReturnType<typeof getAPIDashBoardGetStudentStatus>>, TError = unknown>(
 params: undefined |  GetAPIDashBoardGetStudentStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetStudentStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIDashBoardGetStudentStatus>>,
          TError,
          Awaited<ReturnType<typeof getAPIDashBoardGetStudentStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIDashBoardGetStudentStatus<TData = Awaited<ReturnType<typeof getAPIDashBoardGetStudentStatus>>, TError = unknown>(
 params?: GetAPIDashBoardGetStudentStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetStudentStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIDashBoardGetStudentStatus>>,
          TError,
          Awaited<ReturnType<typeof getAPIDashBoardGetStudentStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIDashBoardGetStudentStatus<TData = Awaited<ReturnType<typeof getAPIDashBoardGetStudentStatus>>, TError = unknown>(
 params?: GetAPIDashBoardGetStudentStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetStudentStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIDashBoardGetStudentStatus<TData = Awaited<ReturnType<typeof getAPIDashBoardGetStudentStatus>>, TError = unknown>(
 params?: GetAPIDashBoardGetStudentStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetStudentStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIDashBoardGetStudentStatusQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAPIDashBoardGetStraeamData = (
    params?: GetAPIDashBoardGetStraeamDataParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<ObjectApiResponse>(
      {url: `/API/DashBoard/GetStraeamData`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIDashBoardGetStraeamDataQueryKey = (params?: GetAPIDashBoardGetStraeamDataParams,) => {
    return [`/API/DashBoard/GetStraeamData`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIDashBoardGetStraeamDataQueryOptions = <TData = Awaited<ReturnType<typeof getAPIDashBoardGetStraeamData>>, TError = unknown>(params?: GetAPIDashBoardGetStraeamDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetStraeamData>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIDashBoardGetStraeamDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIDashBoardGetStraeamData>>> = ({ signal }) => getAPIDashBoardGetStraeamData(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetStraeamData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIDashBoardGetStraeamDataQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIDashBoardGetStraeamData>>>
export type GetAPIDashBoardGetStraeamDataQueryError = unknown


export function useGetAPIDashBoardGetStraeamData<TData = Awaited<ReturnType<typeof getAPIDashBoardGetStraeamData>>, TError = unknown>(
 params: undefined |  GetAPIDashBoardGetStraeamDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetStraeamData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIDashBoardGetStraeamData>>,
          TError,
          Awaited<ReturnType<typeof getAPIDashBoardGetStraeamData>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIDashBoardGetStraeamData<TData = Awaited<ReturnType<typeof getAPIDashBoardGetStraeamData>>, TError = unknown>(
 params?: GetAPIDashBoardGetStraeamDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetStraeamData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIDashBoardGetStraeamData>>,
          TError,
          Awaited<ReturnType<typeof getAPIDashBoardGetStraeamData>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIDashBoardGetStraeamData<TData = Awaited<ReturnType<typeof getAPIDashBoardGetStraeamData>>, TError = unknown>(
 params?: GetAPIDashBoardGetStraeamDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetStraeamData>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIDashBoardGetStraeamData<TData = Awaited<ReturnType<typeof getAPIDashBoardGetStraeamData>>, TError = unknown>(
 params?: GetAPIDashBoardGetStraeamDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetStraeamData>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIDashBoardGetStraeamDataQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAPIDashBoardGetSourseByDate = (
    params?: GetAPIDashBoardGetSourseByDateParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<ObjectApiResponse>(
      {url: `/API/DashBoard/GetSourseByDate`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIDashBoardGetSourseByDateQueryKey = (params?: GetAPIDashBoardGetSourseByDateParams,) => {
    return [`/API/DashBoard/GetSourseByDate`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIDashBoardGetSourseByDateQueryOptions = <TData = Awaited<ReturnType<typeof getAPIDashBoardGetSourseByDate>>, TError = unknown>(params?: GetAPIDashBoardGetSourseByDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetSourseByDate>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIDashBoardGetSourseByDateQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIDashBoardGetSourseByDate>>> = ({ signal }) => getAPIDashBoardGetSourseByDate(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetSourseByDate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIDashBoardGetSourseByDateQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIDashBoardGetSourseByDate>>>
export type GetAPIDashBoardGetSourseByDateQueryError = unknown


export function useGetAPIDashBoardGetSourseByDate<TData = Awaited<ReturnType<typeof getAPIDashBoardGetSourseByDate>>, TError = unknown>(
 params: undefined |  GetAPIDashBoardGetSourseByDateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetSourseByDate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIDashBoardGetSourseByDate>>,
          TError,
          Awaited<ReturnType<typeof getAPIDashBoardGetSourseByDate>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIDashBoardGetSourseByDate<TData = Awaited<ReturnType<typeof getAPIDashBoardGetSourseByDate>>, TError = unknown>(
 params?: GetAPIDashBoardGetSourseByDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetSourseByDate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIDashBoardGetSourseByDate>>,
          TError,
          Awaited<ReturnType<typeof getAPIDashBoardGetSourseByDate>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIDashBoardGetSourseByDate<TData = Awaited<ReturnType<typeof getAPIDashBoardGetSourseByDate>>, TError = unknown>(
 params?: GetAPIDashBoardGetSourseByDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetSourseByDate>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIDashBoardGetSourseByDate<TData = Awaited<ReturnType<typeof getAPIDashBoardGetSourseByDate>>, TError = unknown>(
 params?: GetAPIDashBoardGetSourseByDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetSourseByDate>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIDashBoardGetSourseByDateQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAPIDashBoardGetEnquiryBySource = (
    params?: GetAPIDashBoardGetEnquiryBySourceParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<EnquiryBySourcePagedDataEnquiryBySourceResponseApiResponse>(
      {url: `/API/DashBoard/GetEnquiryBySource`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIDashBoardGetEnquiryBySourceQueryKey = (params?: GetAPIDashBoardGetEnquiryBySourceParams,) => {
    return [`/API/DashBoard/GetEnquiryBySource`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIDashBoardGetEnquiryBySourceQueryOptions = <TData = Awaited<ReturnType<typeof getAPIDashBoardGetEnquiryBySource>>, TError = unknown>(params?: GetAPIDashBoardGetEnquiryBySourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetEnquiryBySource>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIDashBoardGetEnquiryBySourceQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIDashBoardGetEnquiryBySource>>> = ({ signal }) => getAPIDashBoardGetEnquiryBySource(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetEnquiryBySource>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIDashBoardGetEnquiryBySourceQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIDashBoardGetEnquiryBySource>>>
export type GetAPIDashBoardGetEnquiryBySourceQueryError = unknown


export function useGetAPIDashBoardGetEnquiryBySource<TData = Awaited<ReturnType<typeof getAPIDashBoardGetEnquiryBySource>>, TError = unknown>(
 params: undefined |  GetAPIDashBoardGetEnquiryBySourceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetEnquiryBySource>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIDashBoardGetEnquiryBySource>>,
          TError,
          Awaited<ReturnType<typeof getAPIDashBoardGetEnquiryBySource>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIDashBoardGetEnquiryBySource<TData = Awaited<ReturnType<typeof getAPIDashBoardGetEnquiryBySource>>, TError = unknown>(
 params?: GetAPIDashBoardGetEnquiryBySourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetEnquiryBySource>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIDashBoardGetEnquiryBySource>>,
          TError,
          Awaited<ReturnType<typeof getAPIDashBoardGetEnquiryBySource>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIDashBoardGetEnquiryBySource<TData = Awaited<ReturnType<typeof getAPIDashBoardGetEnquiryBySource>>, TError = unknown>(
 params?: GetAPIDashBoardGetEnquiryBySourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetEnquiryBySource>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIDashBoardGetEnquiryBySource<TData = Awaited<ReturnType<typeof getAPIDashBoardGetEnquiryBySource>>, TError = unknown>(
 params?: GetAPIDashBoardGetEnquiryBySourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIDashBoardGetEnquiryBySource>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIDashBoardGetEnquiryBySourceQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



